import React, {createContext, useContext, useState} from 'react';
import {Context} from "../ApiClient";
import Event from "./Event";
import Filters from "./Filters";
import FullCalendar from "@fullcalendar/react";
import frLocale from "@fullcalendar/core/locales/fr";
import dayGridPlugin from "@fullcalendar/daygrid";

import Calendar from 'rc-year-calendar';
import 'rc-year-calendar/locales/rc-year-calendar.fr';

export const EventCalendarContext = createContext({});

export default function EventCalendar() {

    //create Context object

    // Getting object containing events from context, so we need to use braces
    const {events}                                  = useContext(Context);
    let [filteredEvents, setFilteredEvents]         = React.useState([])
    let [monthMode, setMonthMode]                   = React.useState(false)
    let [activeDate, setActiveDate]                 = React.useState(new Date())
    let [fullCalendarEvents, setFullCalendarEvents] = React.useState([])
    let [calendarEvents, setCalendarEvents]         = React.useState([])

    let calendarRef = React.createRef();


    function callbackActiveFilters(filters) {
        filterEvents(events, filters);
    }


    // when filteredEvents is updated, update fullCalendarEvents
    React.useEffect(() => {
            let fullCalendarEvents = filteredEvents.map(event => {

                let dateEnd = new Date(event.date_end);
                // add 1 day to the end date to display the event on the last day
                dateEnd.setDate(dateEnd.getDate() + 1);

                return {
                    title: event.title,
                    start: new Date(event.date),
                    end: dateEnd,
                    url: event.url,
                    allDay: true
                }
            })
            setFullCalendarEvents(fullCalendarEvents);

            let CalendarEvents = filteredEvents.map((event, index) => {
                return {
                    id: index,
                    name: event.title,
                    startDate: new Date(event.date),
                    endDate: new Date(event.date_end),
                    url: event.url,
                }
            })
            setCalendarEvents(CalendarEvents);
        }
        , [filteredEvents])

    function filterEvents(events, filters) {

        // ignore if events is not an array
        if (!Array.isArray(events)) {
            return 1;
        }

        let filteredEvents = events.filter((event) => {
            // Manipulate arrays to compare them
            let eventTerritories = event.territories.split(', ');

            // array unique eventTerritories
            eventTerritories = eventTerritories.filter((value, index, self) => {
                return self.indexOf(value) === index;
            });

            let eventThemes   = event.themes.split(', ');
            let eventMonth    = new Date(event.date).getMonth();
            let eventMonthEnd = new Date(event.date_end).getMonth();
            let eventYear     = new Date(event.date).getFullYear();
            let eventYearEnd  = new Date(event.date_end).getFullYear();

            let filterTerritories = [];
            filters.activeTerritories.forEach((filterTerritory) => {
                // split the territory string to get the territory name and the territory parent
                let territories = filterTerritory.value.split(', ');

                //for each territory, push it in the filterTerritories array
                territories.forEach((territory) => {
                    filterTerritories.push(territory);
                });
            });

            // array unique filterTerritories
            filterTerritories = filterTerritories.filter((value, index, self) => {
                return self.indexOf(value) === index;
            });

            let filterThemes = filters.activeThemes.map(filterThemes => filterThemes.value);
            let filterDate   = activeDate;

            // If event is longer than one month and the filter date is in the middle of the event
            // If monthMode is false, then we compare years only
            // If monthMode is true, then we compare years and months
            let matchDate =
                    (
                        !monthMode
                        // eslint-disable-next-line
                        ||
                        (filterDate.getMonth() >= eventMonth || eventYear < filterDate.getFullYear())
                        // eslint-disable-next-line
                        &&
                        (filterDate.getMonth() <= eventMonthEnd || eventYearEnd > filterDate.getFullYear())
                    )
                    &&
                    (filterDate.getFullYear() >= eventYear && filterDate.getFullYear() <= eventYearEnd);

            const filteredTerritories = eventTerritories.filter(value => filterTerritories.includes(value));
            const filteredThemes      = eventThemes.filter(value => filterThemes.includes(value));

            // If filter is empty, then we return true, else we return true if the event contains the filter and the date is correct
            return (!filterTerritories.length || filteredTerritories.length)
                && (!filterThemes.length || filteredThemes.length)
                && matchDate;
        });


        let searchValues = filters.searchValue.split(' ');
        searchValues     = searchValues.filter(word => word.length > 2);

        // Recherche d'un des mots clés de la barre de recherche dans le titre ou le corps de l'événement
        if (searchValues.length !== 0) {
            filteredEvents = filteredEvents.filter(event =>
                (searchValues.some(searchValue => event.title.toUpperCase().includes(searchValue.toUpperCase()))
                    ||
                    searchValues.some(searchValue => event.body.toUpperCase().includes(searchValue.toUpperCase()))));
        }
        setFilteredEvents(filteredEvents);
    }

    function handleCalendarEventClick(e) {
        // if e.events is not empty, then we clicked on a day with event, then we open the event url
        if (e.events.length === 1) {
            window.open(e.events[0].url, '_blank');
        }
        // if e.events length > 1, then we clicked on a day with multiple events, then we open the month view
        else if (e.events.length > 1) {
            setMonthMode(true);
            setActiveDate(e.date);
        }
        return 0;
    }

    return (
        <EventCalendarContext.Provider
            value={{monthMode, setMonthMode, activeDate, setActiveDate, callbackActiveFilters, calendarRef}}>
            <div className="container">
                <Filters/>

                {monthMode ?
                    <FullCalendar plugins={[dayGridPlugin]} initialView="dayGridMonth"
                                  weekends={true}
                                  events={fullCalendarEvents}
                                  locales={[frLocale]}
                                  locale="fr"
                                  headerToolbar={false}
                                  ref={calendarRef}
                    /> :
                    <Calendar language="fr"
                              dataSource={calendarEvents}
                              year={activeDate.getFullYear()}
                              displayHeader={false}
                        // hiddenWeekDays={[0, 6]}
                              style="custom"
                              padding={9}
                              customDayRenderer={function (element, date) {
                                  element.style.padding = "6px";
                                  // if date is today, then we add a border
                                  if (date.getDate() === new Date().getDate() && date.getMonth() === new Date().getMonth()) {
                                      element.style.borderRadius    = "50%";
                                      element.style.backgroundColor = "#219D3C";
                                      element.style.color = "white";
                                      element.style.border          = "unset";
                                      element.style.padding         = "4px 0px";
                                      element.style.width         = "25px";
                                      element.style.height         = "25px";
                                  }
                              }
                              }
                              customDataSourceRenderer={function (element, date) {
                                  //add round border to the element
                                  element.style.borderRadius    = "50%";
                                  element.style.border          = "1px solid #005683";
                                  element.style.backgroundColor = "#00568326";
                                  element.style.margin          = "1px";
                                  element.style.padding         = "3px 0px";
                                  element.style.width         = "25px";
                                  element.style.height         = "25px";

                                  // if date is today, then we add a border
                                  if (date.getDate() === new Date().getDate() && date.getMonth() === new Date().getMonth()) {
                                      element.style.backgroundColor = "#219D3C";
                                      element.style.border          = "unset";
                                  }
                              }
                              }
                              onDayClick={function (e) {
                                  handleCalendarEventClick(e)
                              }}
                    />
                }

                {/*Fix for the calendar height and scroll, calendar css containing !important, so we need to override here using style*/}
                <style>
                    {`
                    .fc-scroller
                        {
                            max-height: unset !important;
                        }
                    `}
                </style>
            </div>
        </EventCalendarContext.Provider>
    )
}